import { render, staticRenderFns } from "./ici-tour.vue?vue&type=template&id=56032e23&scoped=true&"
import script from "./ici-tour.vue?vue&type=script&lang=js&"
export * from "./ici-tour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56032e23",
  null
  
)

export default component.exports